import React, { ReactElement } from 'react'
import ComissionDisclosure from 'views/cremation/components/CommissionDisclosure'

const ComissionDisclosureInstalments = (): ReactElement => (
  <ComissionDisclosure paymentType="instalments" />
)
export default ComissionDisclosureInstalments
